import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { LastRechargeState } from '../types/lastRecharge';

export const useLastRechargeStore = create<LastRechargeState>()(
  devtools(
    set => ({
      loaded: false,
      date: null,
      value: null,
      nsu: null,
      recipient: null,
      card: null,
      transactionId: null,
      paymentMethod: null,

      setLastRechargeData: data =>
        set({ ...data }, false, 'setLastRechargeData'),
      setLoaded: loaded => set({ loaded }, false, 'setLoaded'),
      clearLastRecharge: () =>
        set(
          {
            loaded: false,
            date: null,
            value: null,
            nsu: null,
            recipient: null,
            card: null,
            transactionId: null,
            paymentMethod: null,
          },
          false,
          'clearLastRecharge',
        ),
    }),
    { name: 'LastRechargeStore' },
  ),
);
